import React, { useState, useEffect } from 'react';
import axios from 'axios';
import RelationshipStep from '../Application/RelationshipStep/RelationshipStep';
import { APPLICATION_STATUS_ID_SUBMITTED, APPLICATION_STATUS_ID_ACCEPTED } from '../Application/constants';

const Relationships = ({ currentUser }) => {
  console.log('Relationships props:', { currentUser });
  const [application, setApplication] = useState(null);

  // Fetch current user data
  useEffect(() => {
    const fetchUser = async () => {
      try {
        // Wait for currentUser to be available
        if (!currentUser?.user_id) {
          console.log('Waiting for currentUser to load...');
          return; // Don't fetch yet if currentUser isn't ready
        }

        const response = await axios.get('/api/applications/my_application');
        const submissions = response.data.filter(
          (s) => s.year === new Date().getFullYear()
        );

        const foundApplication = submissions.find((x) => {
          const isActive = x.active === true;
          const isSubmitted = x.status_id === APPLICATION_STATUS_ID_SUBMITTED;
          const isApproved = x.status_id === APPLICATION_STATUS_ID_ACCEPTED;
          const currentYear = x.year === new Date().getFullYear();
          const isUser = x.user_id === currentUser.user_id;
          return (isActive || isSubmitted || isApproved) && currentYear && isUser;
        });

        if (foundApplication) {
          setApplication(foundApplication);
        }
      } catch (error) {
        console.error('Error fetching application:', error);
      }
    };

    // Only fetch when currentUser is available
    if (currentUser?.user_id) {
      fetchUser();
    }
    // If currentUser is undefined, keep loading (waiting for it to be set)
  }, [currentUser]);

  const handleSaveApplication = async (application) => {
    try {
      const response = await fetch(`/api/applications/${application?.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(application),
      });

      if (!response.ok) {
        throw new Error('Failed to save application');
      }

      return await response.json();
    } catch (error) {
      console.error('Error saving application:', error);
      throw error;
    }
  };

  const handleJumpToStep = (step) => {
    console.log('Navigation to step:', step);
  };

  return (
    <div className="relationships-page">
      <h2 style={{ textAlign: 'center', marginTop: '2em' }}>CLEAR Program Application</h2>

      {application && (
        <RelationshipStep
          application={application}
          saveApplication={handleSaveApplication}
          jumpToStep={handleJumpToStep}
          user={currentUser}
          hideNavigation={true}
        />
      )}
    </div>
  );
};

export default Relationships;